import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-no-result',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './no-result.component.html',
  styleUrl: './no-result.component.scss',
})
export class NoResultComponent {
  @Input() message: string = 'NotMatches';
  @Input() classes: string = 'py-5 max-sm:py-3';
  urlIcon = environment.urlIcon;
}
